import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import {
  danger,
  success,
  showLoading,
} from "../../../components/show-notification";

import api from "../../../providers/api";

import LoadingPanel from "../../../components/loading-painel";

import Layout from "../../../layout";

import validate from "./form-validate";

const RedeSocialCadastrar = () => {
  const location = useLocation();
  const history = useHistory();

  const [stateTipos, setStateTipos] = useState([]);

  const [state, setState] = useState({
    id: 0,
    tipo_rede_social_id: "",
    endereco: "",
  });

  let preencherValoresEdits = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const enviarFormulario = async (e) => {
    e.preventDefault();

    if (!window.$("#form-rede-social").valid()) {
      return;
    }

    try {
      const enviar = state.id > 0 ? api.put : api.post;

      const requisicao = await enviar("/rede-social", state);

      const { data } = requisicao;

      if (!data.status) {
        danger(data.mensagem);
        return;
      }

      if (!data.data) {
        return;
      }

      success(data.mensagem);
      history.push("/rede-social");
    } catch (error) {
      console.log(error);
      danger("Erro ao cadastrar a rede social.");
    }
  };

  const buscarDados = async (url) => {
    const requisicao = await api.get(`${url}`);

    const { data } = requisicao;

    if (!data.status) {
      danger(data.mensagem);
      return;
    }

    if (!data.data) {
      return;
    }

    return data.data;
  };

  const carregarTipos = async () => {
    return await buscarDados("/tipo-rede-social");
  };

  const carregarDados = async () => {
    if (!location.state) {
      return;
    }

    return await buscarDados(`/rede-social/${location.state.id}`);
  };

  useEffect(() => {
    const carregarTodosDados = async () => {
      try {
        showLoading(".ibox-content");

        const [tipos, redeSocial] = await Promise.all([
          carregarTipos(),
          carregarDados(),
        ]);

        setStateTipos(tipos);

        if (redeSocial) {
          setState(redeSocial);
        }

        showLoading(".ibox-content");
      } catch (error) {
        console.log(error);
        showLoading(".ibox-content");
        danger("Erro ao carregar os dados da rede social");
      }
    };

    let validacao = window.$("#form-rede-social").validate(validate);

    carregarTodosDados();

    return () => validacao.destroy();
  }, [location.state]);

  return (
    <>
      <Layout
        titulo="Ibraflex - Redes Sociais"
        header="Cadastro da Rede Social"
        action={{ titulo: "Voltar", link: "/rede-social" }}
      >
        <div className="row">
          <div className="col-lg-12">
            <div className="ibox ">
              <div className="ibox-title">
                <h5>Dados da rede social</h5>
              </div>
              <div className="ibox-content">
                <LoadingPanel />
                <div className="row">
                  <div className="col-lg-12">
                    <form id="form-rede-social">
                      <div className="form-group">
                        <div className="row">
                          <div className="col-lg-4">
                            <label>Selecione o tipo</label>
                            <select
                              className="form-control"
                              id="tipo_rede_social_id"
                              name="tipo_rede_social_id"
                              value={state.tipo_rede_social_id}
                              onChange={(e) => preencherValoresEdits(e)}
                            >
                              <option key="-1" value="">
                                Selecione um tipo
                              </option>

                              {stateTipos.map((tipo) => (
                                <option key={tipo.id} value={tipo.id}>
                                  {tipo.nome}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="col-lg-8">
                            <label>Endereço da rede social</label>
                            <input
                              type="text"
                              placeholder="Endereço da rede social"
                              className="form-control"
                              name="endereco"
                              value={state.endereco}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                      </div>
                      <div>
                        <button
                          className="btn btn-sm btn-success float-right m-t-n-xs"
                          type="submit"
                          onClick={(e) => enviarFormulario(e)}
                        >
                          <strong>Salvar</strong>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default RedeSocialCadastrar;
